// extracted by mini-css-extract-plugin
module.exports = {"img":"BRE-module--img--19BfB","imagecaption":"BRE-module--imagecaption--3RNGb","boxContainer":"BRE-module--boxContainer---sw2B"};